export default "__VITE_ASSET__mzlaetu7__"